import { FlagSet } from './src/feature-flag-client';

export type FlagSet = FlagSet;
export { featureFlagClient } from './src/feature-flag-client';
export { useFeatureFlag } from './src/useFeatureFlag';
